import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 3,
  title: "Chlorine Is an Oxidizer That Actively Raises Your Toddler's Skin pH",
  titleImages: [{
    url: 'https://cdn.magicpatterns.com/uploads/hyJyrjbWxjg7oB5m3uwZ8G/unnamed_(5).jpg',
    alt: 'Scientific cascade diagram showing compounding skin damage over 7 days - Day 1 initial chlorine exposure, Day 4 compounding begins, Day 7 exponential damage with interconnected molecular interactions'
  }],
  mechanism: <>
      When pH rises, the skin's natural protective barrier begins breaking down.
      This isn't a temporary irritation, it's active chemical disruption. The
      skin is literally being chemically altered during the shower.
    </>,
  avatars: {},
  bridge: <>
      Creams can restore pH temporarily, but they{' '}
      <strong data-id="element-97">can't maintain it</strong> against{' '}
      <strong data-id="element-98">daily chlorine exposure</strong>.
    </>,
  imageOnLeft: false
};
export function Item3Section() {
  return <ItemSection data={data} data-id="element-99" />;
}